import PrisonUsersService from '@/services/PrisonUsersService';
import VisitorUsersService from '@/services/VisitorUsersService';
import Vue from 'vue';

const Filters = {
  deliveryStatus: '', // quicker select than bools
  visitorEmail: '',
  prisonerNumber: '',
  delivered: null,
  dispatched: null,
  sentForPrinting: null,
  status: '',
  postType: '', // Digital / Physical
  after: '',
  before: '',
  sort: '-updated_at',
  skip: 1,
  limit: 10,
  printOnSite: false,
  clinicianId: '',
};

export default {
  namespaced: true,
  state: {
    highlightedPhrase: '', // highlighted on card
    postcardMessage: '', // active to show on postcard (changes due to translation)
    filters: { ...Filters },
    defaultFilters: { ...Filters }, // used to set filters back to original
    clinicians: [],
    visitor: null,
    foreignLanguages: [],
    analysis: null,
  },
  getters: {},
  mutations: {
    SET_HIGHLIGHTED_PHRASE(state, phrase) {
      state.highlightedPhrase = phrase;
    },
    SET_ACTIVE_MESSAGE(state, phrase) {
      state.postcardMessage = phrase;
    },
    SET_FILTERS(state, value) {
      state.filters = value;
    },
    SET_FILTER_ITEM(state, item) {
      state.filters[item.name] = item.value;
    },
    SET_DEFAULT_FILTERS(state, value) {
      state.defaultFilters = value;
    },
    SET_CLINICIANS(state, value) {
      state.clinicians = value;
    },
    SET_VISITOR(state, value) {
      state.visitor = value;
    },
    SET_FOREIGN_LANGUAGES(state, value) {
      state.foreignLanguages = value;
    },
    SET_ANALYSIS(state, value) {
      state.analysis = value;
    },
  },
  actions: {
    resetFilters({ commit }, payload) {
      // Create default filters and set the postType
      const defaultFilters = { ...Filters };
      defaultFilters.postType = payload.postType;
      defaultFilters.deliveryStatus = payload.deliveryStatus;
      defaultFilters.status = payload.status;
      defaultFilters.sentForPrinting = payload.sentForPrinting;
      commit('SET_FILTERS', defaultFilters);
    },
    clearFilters({ state, commit }) {
      const newFilters = { ...Filters }

      newFilters.postType = state.filters.postType;

      commit('SET_FILTERS', newFilters);
    },
    refreshClinicians({ commit }) {
      return PrisonUsersService.getClinicians().then(res => {
        commit('SET_CLINICIANS', res.data);
        return res.data;
      }).catch(err => {
        Vue.$toast.error('Could not get staff members, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
        return err;
      });
    },
    getVisitor({ commit }, visitorUserId) {
      VisitorUsersService.getUser(visitorUserId).then(res => {
        commit('SET_VISITOR', res.data);
      }).catch(() => {
        Vue.$toast.error('Could not get sender details, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      })
    },
  },
};
